import React from 'react';
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import classNames from 'classnames';
import noop from '../utils/noop';

function Swipe({
  axis = 'x',
  index = 0,
  enable = false,
  className = '',
  children,
  onChangeIndex = noop,
  onSwitching = noop,
  ...otherProps
}) {
  const swipeClasses = classNames('ws-swipe', className);

  return (
    <div className={swipeClasses}>
      <SwipeableViews
        axis={axis}
        index={index}
        animateTransitions={enable}
        onChangeIndex={onChangeIndex}
        onSwitching={onSwitching}
        enableMouseEvents={enable}
        disabled={!enable}
        {...otherProps}
      >
        {children}
      </SwipeableViews>
    </div>
  );
}

export default Swipe;
